import axios from 'axios';
import endpoints from '../define/endpoints';

export async function useStoreLead(token, user_id, lead) {

    const response = await axios({
        method: 'post',
        url: `${endpoints.core}/leads/store`,
        data: lead,
        headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status !== 200) {
        return false;
    }

    return response.data;
}
